import type { RowTypeKey } from '@tryhackme/thm-ui-components';

import { formatDateTime } from '../../../common/date';

import type {
  CompanySelectOption,
  CompanySubscriberItems,
  SetActiveSortColumnFunction,
  SetFeedbackParamsFunction,
} from './corporate.types';

export const sortData = <T>(
  setActiveSortColumn: SetActiveSortColumnFunction<T>,
  setFeedbackParams: SetFeedbackParamsFunction,
  columnKey: RowTypeKey<T>,
) => {
  setActiveSortColumn(columnKey);
  setFeedbackParams((prevParams) => ({
    ...prevParams,
    sort: prevParams.sort === columnKey.toString() ? `-${columnKey.toString()}` : columnKey.toString(),
  }));
};

export const formatCompanyData = (data: CompanySubscriberItems[]) =>
  data.map((obj) => {
    const added = formatDateTime(obj.added);
    const subExpiry = formatDateTime(obj.subExpiry);
    return { ...obj, subExpiry, added };
  });

export const getInitialCompany = (
  urlCompanyId: string | null,
  data: CompanySelectOption[] = [],
): CompanySelectOption => {
  const urlCompany = data.find((company) => company.id === urlCompanyId);
  if (urlCompany) return urlCompany;

  return {
    id: data[0]?.id ?? '',
    value: data[0]?.value ?? '',
    label: data[0]?.value ?? '',
  };
};
